export const runIdle = (cb: () => void) => {
  if (!process.client || typeof window === 'undefined') {
    cb()
    return
  }

  if ('requestIdleCallback' in window) {
    ;(window as any).requestIdleCallback(cb)
    return
  }

  // Safari fallback
  setTimeout(cb, 100)
}
